import { useEffect } from 'react';

export const usePageTitle = (title) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} | Predict90` : 'Predict90';
    
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
};
